import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'

import * as loadingActions from '../../../state/actions/loading'

import BonPlansJeunesSingleItem from "./BonPlansJeunesSingleItem"

class BonPlansJeunesSingle extends Component {
	_isMounted = false

	constructor(props, context) {
		super(props, context)

		const { urlSingle } = this.props

		// Validation des props
		if (!urlSingle || typeof urlSingle !== 'string') {
			console.warn('BonPlansJeunesSingle: Prop urlSingle requise et doit être une chaîne')
		}

		// Liste des filtres actifs
		this.state = {
			urlSingle: urlSingle ? urlSingle.trim() : '',
			post: null,
			error: null,
			isLoading: true
		}
	}

	componentDidMount() {
		this._isMounted = true
		const { loadingOn } = this.props

		if (loadingOn) {
			loadingOn('BonsPlansJeunesSingle')
		}

		// Démarrer en mode chargement
		this.setState({ isLoading: true }, () => {
			this.launchSingle()
		})
	}

	componentWillUnmount() {
		const { loadingOff } = this.props

		if (loadingOff) {
			loadingOff('BonsPlansJeunesSingle')
		}
		this._isMounted = false
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.urlSingle !== this.state.urlSingle) {
			this.launchSingle()
		}
	}

	launchSingle = () => {
		const { loadingOff } = this.props
		const { urlSingle } = this.state

		// Validation de l'URL
		if (!urlSingle || urlSingle.trim().length === 0) {
			this.setState({ 
				error: 'URL invalide pour le bon plan jeune',
				isLoading: false,
				post: null
			})
			if (loadingOff) {
				loadingOff('BonsPlansJeunesSingle')
			}
			return
		}

		this.setState({ isLoading: true, error: null })

		try {
			let id = urlSingle.split('-')
			id = id[id.length - 1]

			// Validation plus stricte de l'ID
			if (!id || isNaN(parseInt(id)) || parseInt(id) <= 0) {
				throw new Error('Identifiant invalide dans l\'URL')
			}

			const singleQuery = 'https://carto.ville-roubaix.fr/server/rest/services/OpenData/SOLIDARITE/FeatureServer/32/query?where=&objectIds=' + id + '&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnCentroid=false&timeReferenceUnknownClient=false&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=&f=json';
			
			fetch(singleQuery, {
				headers: {},
				method: "GET"
			})
			.then(response => {
				if (!this._isMounted) return

				if (response.status && response.status > 200) {
					throw new Error(`Erreur HTTP: ${response.status}`)
				} else {
					return response.json()
				}
			})
			.then((data) => {
				if (!this._isMounted) return

				// Validation des données reçues
				if (!data || !data.features || !Array.isArray(data.features) || data.features.length === 0) {
					throw new Error('Aucun bon plan trouvé avec cet identifiant')
				}

				this.setState({
					post: data.features[0].attributes,
					isLoading: false,
					error: null
				})

				if (loadingOff) {
					loadingOff('BonsPlansJeunesSingle')
				}
			})
			.catch((error) => {
				if (!this._isMounted) return

				console.warn("Erreur lors de la récupération du bon plan:", error)
				const errorMessage = error.message || "Une erreur est survenue lors de la récupération du bon plan"
				
				this.setState({ 
					error: errorMessage,
					isLoading: false,
					post: null
				})

				if (loadingOff) {
					loadingOff('BonsPlansJeunesSingle')
				}
			})
		} catch (error) {
			if (!this._isMounted) return

			console.warn("Erreur de validation:", error)
			this.setState({ 
				error: error.message || "Erreur de validation des paramètres",
				isLoading: false,
				post: null
			})

			if (loadingOff) {
				loadingOff('BonsPlansJeunesSingle')
			}
		}
	}

	render() {
		const { location, loadingOn, loadingOff } = this.props
		const { post, error, isLoading } = this.state

		// Validation des props
		if (!loadingOn || !loadingOff) {
			return (
				<div 
					className="bons-plans-jeunes-single-error" 
					role="alert" 
					aria-live="polite"
					aria-describedby="bons-plans-jeunes-single-error-description"
				>
					<div id="bons-plans-jeunes-single-error-description" className="visually-hidden">
						Erreur de configuration du composant BonPlansJeunesSingle
					</div>
					<p>Erreur de configuration. Veuillez contacter l'administrateur.</p>
				</div>
			)
		}

		return (
			<div>
				<Helmet>
					<title>Ville de Roubaix : Bon plan jeune</title>
					<meta name="description" content="Détails du bon plan jeune disponible à Roubaix" />
				</Helmet>
				
				<div className="offline-fallback-fix-no-idea-why" aria-hidden="true"></div>
				
				<main 
					className="bons-plans-jeunes-single"
					role="main"
					aria-label="Détails du bon plan jeune"
					aria-describedby="bons-plans-jeunes-single-description"
				>
					<div id="bons-plans-jeunes-single-description" className="visually-hidden">
						Page de détail d'un bon plan jeune avec informations complètes et partage
					</div>

					{error && (
						<div 
							className="alert alert-danger" 
							role="alert" 
							aria-live="polite"
							aria-describedby="bons-plans-jeunes-single-error-description"
						>
							<div id="bons-plans-jeunes-single-error-description" className="visually-hidden">
								Message d'erreur de la page de détail
							</div>
							<h2>Erreur</h2>
							<p>{error}</p>
						</div>
					)}

					{isLoading && (
						<div 
							className="loading-indicator" 
							role="status" 
							aria-live="polite"
							aria-describedby="bons-plans-jeunes-single-loading-description"
						>
							<div id="bons-plans-jeunes-single-loading-description" className="visually-hidden">
								Indicateur de chargement des détails du bon plan jeune
							</div>
							Chargement des détails du bon plan...
						</div>
					)}

					{!isLoading && !error && post && (
						<BonPlansJeunesSingleItem
							shareUrl={location ? location.href : ''}
							postItem={post}
						/>
					)}

					{!isLoading && !error && !post && (
						<div 
							className="no-content" 
							role="status" 
							aria-live="polite"
						>
							<p>Aucun contenu disponible pour ce bon plan jeune.</p>
						</div>
					)}
				</main>
			</div>
		)
	}
}

export default connect(null, loadingActions)(BonPlansJeunesSingle)
